module.exports = __webpack_public_path__ + "static/img/4.1cc9ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dww/4.png
// module id = wTO9
// module chunks = 0